import React from "react";
import { Button, Modal } from "react-bootstrap";

const DeleteConfirmationModal = ({
  Title,
  Message,
  deleteConfirmationModal,
  setDeleteConfirmationModal,
  deleteRow,
}) => {
  const handleSubmit = () => {
    deleteRow();
  };

  return (
    <div>   
      <Modal
        backdrop="static"
        keyboard={false}
        size="sm"
        show={deleteConfirmationModal}
        onHide={() => {
          deleteConfirmationModal
            ? setDeleteConfirmationModal(false)
            : setDeleteConfirmationModal(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>{Title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <h6>{Message}</h6>
        </Modal.Body>
        <hr className="my-0" />
        <Modal.Footer className="pb-2">
          <Button
            type="submit"
            variant="danger"
            className="btn-sm "
            onClick={() => handleSubmit()}
          >
            Delete
          </Button>
          <Button
            type="button"
            variant="secondary"
            className="btn-sm"
            onClick={() => {
              deleteConfirmationModal
                ? setDeleteConfirmationModal(false)
                : setDeleteConfirmationModal(false);
            }}
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default DeleteConfirmationModal;
